import React, { useEffect, useLayoutEffect, useState } from 'react';
import {STDStyle, StdBody, StdFooter, StdDivInitial, StdMain, StdTop} from './style';
import Header from '@/layout/header';
import Footer from '@/layout/footer';


const Std = ({children, withoutMenu}) => {
  const [width, setWidth] = useState(window.innerWidth || window.screen.width || document.documentElement.clientWidth || document.body.clientWidth);
  const [height, setHeight] = useState(window.innerHeight || window.screen.height || document.documentElement.clientHeight || document.body.clientHeight);

  useLayoutEffect(() => {
   
    const handleResize = () => {
      setWidth(window.innerWidth || window.screen.width || document.documentElement.clientWidth || document.body.clientWidth);

      setHeight(window.innerHeight || window.screen.height || document.documentElement.clientHeight || document.body.clientHeight);
    };

    window.addEventListener('resize', handleResize);
   
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    getCookie();
  }, [])
  
  const getCookie = () =>{
    const cookies = document.cookie.split('; ').reduce((acc, c) => {
      const [k, v] = c.split('=');
      acc[k] = decodeURIComponent(v);
      return acc;
    }, {});

    const payload = cookies[process.env.WORD_CRYPTO];
    if(payload){
      window.location.href = `${process.env.API_BASE_PATH}/auth/admin`;
    }
  }
  return (
    <STDStyle height={`${height}px`} width={`${width}px`}>
      <StdDivInitial>
        <StdMain>
          <StdTop>
            <Header  withoutMenu={withoutMenu} />
          </StdTop>
          <StdBody>
            {children}
          </StdBody>
        </StdMain>  
        <StdFooter>
          <Footer />
        </StdFooter>      
      </StdDivInitial>
      
    </STDStyle>
  );
};

export default Std;
